import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const adminTicketRoutes: RouteRecordRaw[] = [
  {
    path: '/ticket',
    name: 'Ticket',
    component: Layout,
    meta: {
      title: '任务中心',
      icon: 'mdi:ticket-outline',
      alwaysShow: true
    },
    children: [
      {
        path: 'task-category',
        name: 'TicketTaskCategory',
        component: () => import('@/views/Admin/Ticket/Task/Category.vue'),
        meta: {
          title: '任务分类',
          icon: 'mdi-format-list-bulleted'
        }
      },
      {
        path: 'task',
        name: 'TicketTask',
        component: () => import('@/views/Admin/Ticket/Task/Index.vue'),
        meta: {
          title: '任务配置',
          icon: 'mdi-cog-outline'
        }
      },
      {
        path: 'task-log',
        name: 'TicketTaskLog',
        component: () => import('@/views/Admin/Ticket/Task/Log.vue'),
        meta: {
          title: '任务记录',
          icon: 'mdi-clipboard-text-outline'
        }
      },
      {
        path: 'prize-center',
        name: 'TicketPrizeCenter',
        component: () => import('@/views/Admin/Ticket/Prize/Center.vue'),
        meta: {
          title: '奖品中心',
          icon: 'mdi-gift-outline'
        }
      },
      {
        path: 'prop-type',
        name: 'TicketPropType',
        component: () => import('@/views/Admin/Ticket/Prop/Type.vue'),
        meta: {
          title: '道具类型',
          icon: 'mdi-shape-outline'
        }
      },
      {
        path: 'prop',
        name: 'TicketProp',
        component: () => import('@/views/Admin/Ticket/Prop/List.vue'),
        meta: {
          title: '道具',
          icon: 'mdi-cube-outline'
        }
      }
    ]
  }
]

export default adminTicketRoutes
